var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"failOrderTip"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"msg"},[_vm._v(_vm._s(_vm.obj.msg))]),(this.obj.type != 'sign')?_c('div',{staticClass:"option"},[_c('el-button',{attrs:{"size":"mini"},on:{"click":_vm.goMsg}},[_vm._v("去处理")])],1):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }